define(
	'CV.TariffCalculation.TariffModule'
	, [
		'CV.TariffCalculation.TariffModule.View',
		'Header.MiniCartItemCell.View',
		'ProductViews.Price.View',
		'Transaction.Line.Views.Price.View',
		'Profile.Model',
		'Configuration',
		'Header.MiniCart.View',
		// 'Transaction.Line.Views.QuantityAmount.View',
		// 'OrderHistory.Details.View'

	]

	, function (
		TariffModuleView,
		HeaderMiniCartItemCellView,
		PriceView,
		TransactionLineViewsPriceView,
		ProfileModel,
		Configuration,
		HeaderMiniCartView,
		// TransactionLineViewsQuantityAmountView,
		// OrderHistoryDetailsView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				// using the 'Layout' component we add a new child view inside the 'Header' existing view 
				// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
				// more documentation of the Extensibility API in
				// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');
				var cart = container.getComponent("Cart");

				if (cart) {
					cart.on('afterAddLine', function onAfterAddLine(data) {
						var line;
						// if (data && data.line) {
						// 	console.log('Added Line Details', data);
						// }
					});
				}
				// if you want to add the view to the Header, uncomment the following lines			

				_.extend(PriceView.prototype, {

					getContext: function () {
						// console.log('this.model from price', this.model);
						// console.log('this.model from price 2', this.model.get('item'));
						const price_container_object = this.model.getPrice();
						const is_price_range = !!(price_container_object.min && price_container_object.max);
						let showComparePrice = false;
						const frequency = this.model.get('frequency');
						const frequency_label = (frequency) ? (' / ' + frequency) : '';
						var tariffVal = this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff');
						// console.log('tariffVal', tariffVal);

						if (!this.options.hideComparePrice) {
							showComparePrice = is_price_range
								? price_container_object.max.price < price_container_object.compare_price
								: price_container_object.price < price_container_object.compare_price;
						}

						// @class ProductViews.Price.View.Context
						return {
							// @property {Boolean} isPriceEnabled
							isPriceEnabled: !ProfileModel.getInstance().hidePrices(),
							// @property {String} urlLogin
							urlLogin: this.getUrlLogin(),

							// @property {Boolean} isPriceRange
							isPriceRange: is_price_range,
							// @property {Boolean} showComparePrice
							showComparePrice: showComparePrice,
							// @property {Boolean} isInStock
							isInStock: this.model.getStockInfo().isInStock,
							// @property {Item.Model|Product.Model} model
							model: this.model,
							// @property {String} currencyCode
							currencyCode: SC.getSessionInfo('currency')
								? SC.getSessionInfo('currency').code
								: '',
							// @property {String} priceFormatted
							priceFormatted: price_container_object.price_formatted || '',
							// @property {String} comparePriceFormatted
							comparePriceFormatted: price_container_object.compare_price_formatted || '',
							// @property {String} minPriceFormatted
							minPriceFormatted: price_container_object.min
								? price_container_object.min.price_formatted
								: '',
							// @property {String} maxPriceFormatted
							maxPriceFormatted: price_container_object.max
								? price_container_object.max.price_formatted
								: '',
							// @property {Number} price
							price: price_container_object.price ? price_container_object.price : 0,
							// @property {Number} price
							frequency: frequency_label,
							// @property {Number} comparePrice
							comparePrice: price_container_object.compare_price
								? price_container_object.compare_price
								: 0,
							// @property {Number} minPrice
							minPrice: price_container_object.min ? price_container_object.min.price : 0,
							// @property {Number} maxPrice
							maxPrice: price_container_object.max ? price_container_object.max.price : 0,
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_cv_tariffs') : this.model.get('custitem_cv_tariffs'),
							tariff: parseFloat(tariffVal) > 0 ? tariffVal : '',
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff'),


							// @property {Boolean} showHighlightedMessage
							showHighlightedMessage:
								_.indexOf(PriceView.highlightedViews, this.options.origin) >= 0
						};
						// @class ProductViews.Price.View
					}
				});
				_.extend(HeaderMiniCartItemCellView.prototype, {
					getContext: function () {
						// console.log('this.model from HeaderMiniCartItemCellView', this.model);
						const price_container_object = this.model.getPrice();

						var tariffVal = this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff');
						// @class Header.MiniCart.View.Context
						return {
							line: this.model,
							// @property {Number} itemId
							itemId: this.model.get('item').id,
							// @property {String} itemType
							itemType: this.model.get('item').get('itemtype'),
							// @property {String} linkAttributes
							linkAttributes: this.model.getFullLink({
								quantity: null,
								location: null,
								fulfillmentChoice: null
							}),
							// @property {ImageContainer} thumbnail
							thumbnail: this.model.getThumbnail(),
							// @property {Boolean} isPriceEnabled
							isPriceEnabled: !ProfileModel.getInstance().hidePrices(),
							// @property {Boolean} isFreeGift
							isFreeGift: this.model.get('free_gift') === true,
							tariff: parseFloat(tariffVal) > 0 ? tariffVal : '',
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff'),
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_cv_tariffs') : this.model.get('custitem_cv_tariffs'),

							// @property {String} rateFormatted
							rateFormatted:
								price_container_object.price_formatted || this.model.get('rate_formatted') || ''
						};
						// @class Header.MiniCart.View
					}
				})
				_.extend(TransactionLineViewsPriceView.prototype, {
					getContext: function () {
						// console.log('this.model from TransactionLineViewsPriceView', this.model);
						const price_container_object = this.model.getPrice();
						const showComparePrice =
							this.options.showComparePrice &&
							price_container_object.price < price_container_object.compare_price;

						// @class Transaction.Line.Views.Price.View.Context
						var tariffVal = this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff');
						return {
							// @property {Transaction.Line.Model} model
							model: this.model,
							// @property {Boolean} showComparePrice
							showComparePrice: showComparePrice,
							// @property {Boolean} isInStock
							isInStock: !!this.model.getStockInfo().isInStock,
							// @property {String} currencyCode
							currencyCode:
								(SC.getSessionInfo('currency') && SC.getSessionInfo('currency').code) ||
								SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
							// @property {String} comparePriceFormatted
							comparePriceFormatted: price_container_object.compare_price_formatted || '',
							// @property {Number} price
							price: price_container_object.price || 0,
							// @property {String} rateFormatted
							tariff: parseFloat(tariffVal) > 0 ? tariffVal : '',
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_scs_web_tariff') : this.model.get('custitem_scs_web_tariff'),
							// tariff: this.model.get('item') ? this.model.get('item').get('custitem_cv_tariffs') : this.model.get('custitem_cv_tariffs'),

							rateFormatted:
								this.model.get('rate_formatted') || price_container_object.price_formatted || '',
							// @property {Boolean} isPriceEnabled
							isPriceEnabled: this.isPriceEnabled,
							// @property {String} urlLogin
							urlLogin: this.getUrlLogin()
						};
						// @class Transaction.Line.Views.Price.View
					}
				});

				// _.extend(TransactionLineViewsQuantityAmountView.prototype, {
				// 	getContext: function () {
				// 		console.log('this.model from TransactionLineViewsQuantityAmountView', this.model);
				// 		// @class ItemViews.Item.QuantityAmount.View.Context
				// 		var options = this.model.get('options').models;
				// 		var tariffOption = options.find(option => option.get('cartOptionId') == 'custcol_scs_item_tariff');
				// 		console.log('options from tariff', tariffOption);
				// 		var tariff = tariffOption && tariffOption.get('value').internalid != null ? tariffOption.get('value').internalid : '';
				// 		console.log('tariff', tariff);

				// 		return {
				// 			// @property {Model} line
				// 			line: this.model,
				// 			// @property {String} lineId
				// 			lineId: this.model.get('internalid'),
				// 			// @property {Boolean} showQuantity
				// 			showQuantity: this.model.get('item').get('_itemType') !== 'Discount',
				// 			// @property {Boolean} showDiscount
				// 			showDiscount: !!this.model.get('discount'),
				// 			// @property {Boolean} showAmount
				// 			showAmount: !!this.model.get('amount'),
				// 			tariff: tariff == 'null' ? '' : tariff
				// 		};
				// 		// @class ItemViews.Item.QuantityAmount.View
				// 	}
				// });

				// _.extend(OrderHistoryDetailsView.prototype, {
				// 	getNonShippableLines: function () {
				// 		console.log('this.model from OrderHistoryDetailsView', this.model.get('lines'));
						
				// 		var itemIds = this.model.get('lines').models;
				// 		// console.log('itemIds', itemIds);
				// 		var nonshippableLines = this.model.get('lines').where({ linegroup: 'nonshippable'});
				// 		// console.log('itemIds nonship', this.model.get('lines').where({ linegroup: 'nonshippable'}));
				// 		var trifItem = nonshippableLines.find(line => line.get('item').get('internalid') == '42221');
				// 		// console.log('trifItem', trifItem);
				// 		nonshippableLines = nonshippableLines.filter(line => line.get('item').get('internalid') != '42221');
				// 		// console.log('nonshippableLines after filter', nonshippableLines);
				// 		// return this.model.get('lines').where({ linegroup: 'nonshippable'});
				// 		return nonshippableLines;
				// 	}
				// });


			}
		};
	});
